import { QuillEditorActionTypes, SelectionEndMenuTypes } from 'src/researcher/models';
import {
  Contextmenu,
  ContextmenuActions,
  ContextmenuActionEnum,
} from 'src/researcher/types/contextmenu';

const defaultState: Contextmenu = {
  quillActionType: QuillEditorActionTypes.RESET,
  mousePosition: null,
  selectedText: '',
  markerPostion: -1,
  citationData: null,
  paraphraserMetaData: null,
  summarizerdMetaData: null,
  selectionEndMenu: SelectionEndMenuTypes.NONE,
};

export function contextmenuReducer(state = defaultState, action: ContextmenuActions): Contextmenu {
  switch (action.type) {
    case ContextmenuActionEnum.UpdateMousePosition: {
      return {
        ...state,
        mousePosition: action.payload.mousePosition,
        contextMenuContainer: action.payload.contextMenuContainer,
        selectionEndMenu: action.payload.selectionEndMenu,
      };
    }
    case ContextmenuActionEnum.UpdateSelectedText: {
      return {
        ...state,
        selectedText: action.payload.selectedText,
      };
    }
    case ContextmenuActionEnum.SET_QUILL_ACTION_TYPE: {
      return {
        ...state,
        quillActionType: action.payload.quillActionType,
      };
    }
    case ContextmenuActionEnum.ToggleShouldSearchSelectedText: {
      return {
        ...state,
        shouldSearchSelectedText: !state.shouldSearchSelectedText,
      };
    }
    case ContextmenuActionEnum.UpdateParaphraserMetaData: {
      return {
        ...state,
        paraphraserMetaData: action.payload,
      };
    }
    case ContextmenuActionEnum.UpdateSummarizerdMetaData: {
      return {
        ...state,
        summarizerdMetaData: action.payload,
      };
    }
    case ContextmenuActionEnum.SetMarkerPostion: {
      return {
        ...state,
        markerPostion: action.payload,
      };
    }
    case ContextmenuActionEnum.SetSelectionMetaData: {
      const nextState = {
        ...state,
      };
      if (typeof action.payload.selectedText !== 'undefined') {
        nextState.selectedText = action.payload.selectedText;
      }
      if (typeof action.payload.citationData !== 'undefined') {
        nextState.citationData = action.payload.citationData;
      }
      return nextState;
    }
    case ContextmenuActionEnum.ResetStore: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}
